import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-pale px-4 py-6 md:px-12 md:py-7" data-id="element-64" data-mp="4uqfz2u0sewh">
      <div className="flex gap-3 rounded-md border border-gold bg-white p-3.5 md:p-4" data-id="element-65" data-mp="4x34xzy73pj1">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-gold" strokeWidth={1.75} aria-hidden data-id="element-66" data-mp="9wfq8g9f4oji" />
        <div data-id="element-67" data-mp="euqwyi4f2ixi">
          <h2 className="font-heading text-[17px] font-extrabold uppercase leading-[1.15] tracking-[-0.2px] text-navy md:text-[21px]" data-id="element-68" data-mp="er36jru9qcn0">
            Your purchase is protected
          </h2>
          <p className="mt-0.5 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-69" data-mp="ns19s7wvug4j">
            7-day money-back guarantee
          </p>
          <p className="mt-1 text-[14px] leading-[1.37] text-ink md:text-[15px]" data-id="element-70" data-mp="xivyrk1ijtto">
            Explore the Complete Speech Therapy Activities Bundle™ for seven days. Review the four main volumes,
            articulation exercises, receptive and expressive language activities, social communication resources, and
            four free professional bonuses. If the materials aren't right for your needs, you may request a refund
            within seven days, subject to the refund policy published by the store.
          </p>
        </div>
      </div>
    </section>;
}